<ng-container *ngIf="{checkin_status: checkin_status$ | async} as vm">
    <ng-container *ngIf="!hidden">
        <penji-member-checkin-status [checkin_status]="vm.checkin_status!"></penji-member-checkin-status>
    </ng-container>
</ng-container>
